import React from 'react';

interface Asset {
  id: number;
  name: string;
}

interface AssetTagsProps {
  assets: Asset[];
  maxVisible?: number;
  className?: string;
  showEllipsis?: boolean;
  onShowMoreClick?: () => void;
}

const AssetTags: React.FC<AssetTagsProps> = ({
  assets,
  maxVisible = 4,
  className = '',
  showEllipsis = true,
  onShowMoreClick,
}) => {
  if (!assets || assets.length === 0) {
    return (
      <div className={`flex items-center justify-between ${className}`}>
        <span className="text-gray-500 italic text-sm">No linked assets</span>
        {showEllipsis && <span className="text-gray-400 text-lg">⋯</span>}
      </div>
    );
  }

  const visibleAssets = assets.slice(0, maxVisible);
  const remainingCount = assets.length - maxVisible;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center gap-2 flex-wrap">
        {visibleAssets.map((asset) => (
          <div
            key={asset.id}
            className="px-3 py-1.5 bg-purple-100 text-purple-800 rounded-full text-sm font-medium hover:bg-purple-200 transition-colors"
            title={asset.name} // Show full name on hover
          >
            {asset.name}
          </div>
        ))}
        {remainingCount > 0 && (
          <div
            className="px-3 py-1.5 bg-white border border-purple-800 text-purple-800 rounded-full text-sm font-medium hover:bg-purple-50 transition-colors cursor-pointer"
            title={`${remainingCount} more assets`}
            onClick={onShowMoreClick}
          >
            +{remainingCount} more
          </div>
        )}
      </div>
      {showEllipsis && (
        <span className="text-purple-800 text-lg ml-2 cursor-pointer hover:text-purple-600">
          ⋯
        </span>
      )}
    </div>
  );
};

export default AssetTags;
